import { render } from "./VideoEditors.vue.js?vue&type=template&id=4db32352!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoEditors.vue?vue&type=template&id=4db32352"
import script from "./VideoEditors.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoEditors.vue?vue&type=script&lang=js"
export * from "./VideoEditors.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoEditors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/VideoEditors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4db32352"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4db32352', __exports__)) {
    api.reload('4db32352', __exports__)
  }
  
  module.hot.accept("./VideoEditors.vue.js?vue&type=template&id=4db32352!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoEditors.vue?vue&type=template&id=4db32352", () => {
    api.rerender('4db32352', render)
  })

}


export default __exports__